import { t } from "@lingui/macro";

export const GPT_LANGUAGES = [
  {
    id: "en",
    unicode: "🇬🇧",
    getDisplayName: () => t`english`,
  },
  {
    id: "be",
    unicode: "🇧🇾",
    getDisplayName: () => t`belarusian`,
  },
  {
    id: "de",
    unicode: "🇩🇪",
    getDisplayName: () => t`german`,
  },
  {
    id: "es",
    unicode: "🇪🇸",
    getDisplayName: () => t`spanish`,
  },
  {
    id: "el",
    unicode: "🇬🇷",
    getDisplayName: () => t`greek`,
  },
  {
    id: "it",
    unicode: "🇮🇹",
    getDisplayName: () => t`italian`,
  },
  {
    id: "kk",
    unicode: "🇰🇿",
    getDisplayName: () => t`kazakh`,
  },
  {
    id: "tr",
    unicode: "🇹🇷",
    getDisplayName: () => t`turkish`,
  },
  {
    id: "pt",
    unicode: "🇵🇹",
    getDisplayName: () => t`portuguese`,
  },
  {
    id: "ro",
    unicode: "🇷🇴",
    getDisplayName: () => t`romanian`,
  },
  {
    id: "ru",
    unicode: "🇷🇺",
    getDisplayName: () => t`russian`,
  },
  {
    id: "fr",
    unicode: "🇫🇷",
    getDisplayName: () => t`french`,
  },
  {
    id: "uk",
    unicode: "🇺🇦",
    getDisplayName: () => t`ukrainian`,
  },
] as const;
